module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0015.jpg?v=de5d721b";